
import {
  QUOTATIONS_PAGINATOR_SET_CONFIGURATION_DONE_QUOTATIONS,

  QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_REQUEST,
  QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_SUCCESS,
  QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_ERROR,
} from 'Redux/types/tableQuotationsTypes';
import paginate from 'Redux/reducers/paginationReducer';


const quotationsSlopes = paginate({
  setPaginationConfigType: QUOTATIONS_PAGINATOR_SET_CONFIGURATION_DONE_QUOTATIONS,
  types: [
    QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_REQUEST,
    QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_SUCCESS,
    QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_ERROR,
  ],
});

export default quotationsSlopes;
